import { useModalPromises } from "kreate-common/modules/kreate-ui/components/Modal/hoc/withModalPromises";

import ModalCollectorListViewer from ".";

export function useModalTrigger$ModalCollectorListViewer() {
  const { showModal } = useModalPromises();

  const openModal = async (params$GetCollectors: {
    artworkId?: string | undefined;
    collectionId?: string | undefined;
    userId?: string | undefined;
  }) =>
    await showModal<void>(({ resolve }) => (
      <ModalCollectorListViewer
        open
        onClose={() => resolve()}
        params$GetCollectors={params$GetCollectors}
      />
    ));

  return { openModal };
}
